'use strict';

var util = angular.module('gymsystem.util');

util.factory('eventlog', ['$modal', function($modal) {
    return {
        openDialog: function(option) {
            $modal.open({
                templateUrl: 'components/eventlog/eventlog.dialog.html',
                windowClass: 'huge-modal-window',
                controller: ['$scope', function($scope) {
                    $scope._eventlog_option = option;
                }]
            });
        }
    };
}]);

util.controller('EventLogCtrl', ['$rootScope', '$scope', '$controller', '$q', '$filter', 'server', 'Link', 'resourceBooking', '$modal', 'excel', '$location', function($rootScope, $scope, $controller, $q, $filter, server, Link, $resourceBooking, $modal, excel, $location) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.logitems = [];
    $scope.linkFilter = [];
    var types = [];
    var apps = [];
    var onReady = [];
    onReady.push(server.post2('/api/eventlog/type/get').then(function(result) {
        types = result.map(function(type) {
            return {
                id: type,
                name: $filter('translate')('event_' + type)
            };
        });
    }));

    onReady.push(server.get('/api/eventlog/app/get').then(function(result) {
        apps = result;
    }));

    var cancelPreviousRequest;
    $scope.loadingStatus = {};
    var inited = false;

    var getLogEntries = _.debounce(function() {
        if(!inited) {return;}
        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }
        cancelPreviousRequest = $q.defer();

        var args = $scope.getSubmitItem();
        var event = null;
        if(args.types) {
            event = _.pluck(args.types, 'id');
        }

        var links = $scope.linkFilter.slice();
        if(args.customer) {
            links.push(new Link('user', args.customer));
        }
        if(args.cashregister) {
            links.push(new Link('cashregister', args.cashregister.id));
        }

        var query = {
            from_date: _.findWhere($scope.fields, {name: 'fromDate'}).value,
            to_date: _.findWhere($scope.fields, {name: 'toDate'}).value,
            event: event,
            links: links,
        };

        if(args.performer_customer) {
            query.performer = new Link('user', args.performer_customer);
        } else if(args.performer_system) {
            query.performer = null;
        }

        $scope.loadingStatus.loading = true;
        server.post2('/api/eventlog/search2', {query:query}, {timeout: cancelPreviousRequest.promise}).then(function(response) {
            $rootScope.waitFor(['staffs', 'members']).then(function() {
                $scope.logitemsCount = response.count;
                $scope.logitems = response.result;
                $scope.loadingStatus.loading = false;
                $scope.page.recalc();
            });
        });
    }, 800);

    $scope.page = (function() {
        var page = {};
        page.current = 0;

        var list = [];
        page.recalc = function() {
            page.current = 0;
            list = [];
            for(var i=0;i*100<$scope.logitems.length;i++) {
                list.push(i);
            }
        };
        page.prev = function() {if(page.current) {page.current--;}};
        page.next = function() {if(!page.lastPage()) {page.current++;}};
        page.set = function(n) {page.current=n;};
        page.list = function() {
            var start = _.max([page.current - 5, 0]);
            return list.slice(start, start + 10);
        };
        page.lastPage = function() {
            return (page.current + 1) >= list.length;
        };
        page.items = function() {
            return $scope.logitems.slice(page.current*100, page.current*100 + 100);
        };

        return page;
    })();

    setTimeout(function() {
        inited = true;
        getLogEntries();
    }, 100);

    $scope.getPerformer = function(link, performer_name) {
        if(!link) {return '';}
        if(link.type === 'user' && link.id === $rootScope.superUserId) {
            return $filter('translate')('Zoezi support') + (performer_name ? ' (' + performer_name + ')' : '');
        }
        var obj = link.getObjectSync();
        if(!obj) {return '';}
        var prefix = $filter('translate')({staff: 'Staff', member: 'Customer', user: 'Person'}[link.type]);
        return prefix + ' ' + obj.name;
    };

    $scope.getNameByLink = function(link, item) {
        if (!link) {return '';}
        if (link.type == 'user' && link.id === $rootScope.superUserId) {
            return $filter('translate')('Zoezi support');
        }
        if (link.type == 'valuecardtotal') {
            var d = item?.diff?.[0];
            if (d?.key == 'amount') return (d.old || 0).toFixed(2) + ' ⇒ ' + (d.new || 0).toFixed(2);
        }
        var obj = link.getObjectSync();
        if (obj) {
            return obj.name;
        }
        return $filter('translate')(link.type) + ' ' + link.id;
    };

    $scope.getApp = function(app) {
        return _.findWhere(apps, {id: app.id});
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: false, type: 'date', value: Date.today(), change: getLogEntries },
        {name: 'toDate', title: 'To', required: false, type: 'date', value: Date.today(), change: getLogEntries },
        {name: 'customer', title: 'Person', required: false, type: 'customer' },
        {name: 'cashregister', title: 'Cashier', required: false, type: 'cashier', visible: function() { return $rootScope.hasModule('Checkout'); } },
        {
            name: 'types',
            title: 'Event type',
            required: false,
            type: 'multiselect',
            options: function() { return types; },
            group: (function() {
                var events = {'created': 1, 'updated': 1, 'price_updated': 1, 'status_updated': 1, 'vat_updated': 1, 'cancelled': 1, 'freezed': 1, 'unfreezed': 1, 'deleted': 1, 'used': 1, 'rebooked': 1, 'confirmed': 1, 'credited': 1, 'opened': 1, 'closed': 1, 'attendance': 1, 'merged': 1, 'expired': 1};
                return function(item) {
                    if(events[item.id]) {return 'EVENT_TEXT';}
                    return 'Object';
                };
            })(),
            change: getLogEntries
        },
        {name: 'performer', title: 'Performed by', required: false, type: 'label' },
        {name: 'performer_system', title: 'System', required: false, type: 'checkbox', change: getLogEntries },
        {name: 'performer_customer', title: 'Person', required: false, type: 'customer' }
    ];
    $scope.hideSubmitButton = true;

    $scope.selectEvent = function(event) {
        _.findWhere($scope.fields, {name: 'types'}).value = types.filter(function(t) {return t.id===event;});
        getLogEntries();
    };

    $scope.addLinkFilter = function(link) {
        if(!link) {return;}
        if(_.findWhere($scope.linkFilter, {id: link.id, type: link.type})) {return;}
        $scope.linkFilter.push(link);
        getLogEntries();
    };

    $scope.removeLinkFilter = function(link, index) {
        if(!link) {return;}
        $scope.linkFilter.splice(index, 1);
        getLogEntries();
    };

    $scope.selectPerformer = function(link) {
        if(!link) {return;}
        if(link.type === 'user') {
            _.findWhere($scope.fields, {name: 'performer_customer'}).value = link.getObjectSync();
        }
    };

    $scope.canOpen = (function() {
        var types = {
            user: 1,
            member: 1,
            staff: 1,
            resourcebooking: 1,
            paymentmethod: 1,
            trainingcardtype: 1,
            trainingcard: 1
        };
        return function(link) {
            if(link && link.type === 'user' && link.id === 1) {return false;}
            return types[link && link.type];
        };
    })();

    $scope.openLink = function(link) {
        if(!link) {return;}
        if(link.type === 'member' || link.type === 'user') {
            var obj = link.getObjectSync();
            if(obj) {
                $rootScope.gotoCustomer(obj);
            }
        } else if(link.type === 'staff') {
            var obj = link.getObjectSync();
            if(obj) {
                $rootScope.gotoStaff(obj);
            }
        } else if(link.type === 'resourcebooking') {
            $resourceBooking.openById(link.id);
        } else if(link.type === 'paymentmethod') {
            var method = link.getObjectSync();
            if(method) {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'SettingsPaymentMethodChangeModalCtrl',
                    resolve: {
                        method: function() {
                            return method;
                        }
                    }
                });
            }
        } else if(link.type === 'trainingcardtype') {
            var product = link.getObjectSync();
            if(product) {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: ($rootScope.isProduct(product) || product.discount) ? 'ProductChangeModalCtrl': 'TrainingCardTypeChangeModalCtrl',
                    resolve: {
                        product: function() {
                            return product;
                        },
                        trainingCardType: function() {
                            return product;
                        }
                    }
                });
            }
        } else if(link.type === 'trainingcard') {
            link.getObject().then(function(card) {
                $modal.open({
                    templateUrl: 'views/changetrainingcard.html',
                    controller: 'TrainingCardChangeModalCtrl',
                    resolve: {
                        card: function() {
                            return card;
                        }
                    }
                });
            });
        }
    };

    $scope.openLog = function(log) {
        $modal.open({
            templateUrl: 'components/eventlog/eventlog-item.html',
            controller: 'EventLogCtrlItem',
            windowClass: 'huge-modal-window',
            resolve: {
                log: function() {
                    return log;
                }
            }
        });
    };

    $scope.exportToExcel = function() {
        excel.load().then(function() {
            var data = [
                [{value: 'Time'},
                {value: 'Event type'},
                {value: 'Object'},
                {value: 'Performed by'},
                {value: 'Description'}]
            ];

            $scope.logitems.forEach(function(log) {
                data.push([
                    {value: log.created.dateTime() },
                    {value: log.events.map(function(e) {return $filter('translate')('event_' + e);}).join(' ,')},
                    {value: $scope.getNameByLink(log.object)},
                    {value: $scope.getPerformer(log.performer, log.performer_name)},
                    {value: log.description}
                ]);
            });

            var title = $filter('translate')('Event log');
            var excelData = createExcel(title, data);
            excel.download(excelData, title + '.xlsx');
        });
    };


    function getCustomer() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    }

    function getCashRegister() {
        return _.findWhere($scope.fields, {name: 'cashregister'}).value;
    }

    function getPerformerCustomer() {
        return _.findWhere($scope.fields, {name: 'performer_customer'}).value;
    }

    $scope.$watch(getCustomer, getLogEntries);
    $scope.$watch(getCashRegister, getLogEntries);
    $scope.$watch(getPerformerCustomer, getLogEntries);

    var option = $scope.$parent._eventlog_option;
    if(option) {
        $q.all(onReady).then(function() {
            if(option.filter) { $scope.linkFilter.push(option.filter); }
            if(option.event) {
                var field = _.findWhere($scope.fields, {name: 'types'});
                field.value = [];
                var events = Array.isArray(option.event)?option.event:[option.event];
                events.forEach(function(e) {
                    field.value.push(_.findWhere(types, {id: e}));
                });
            }
            if(option.noPeriod) {
                _.findWhere($scope.fields, {name: 'fromDate'}).value = null;
                _.findWhere($scope.fields, {name: 'toDate'}).value = null;
            }
            if(option.hideFilter) { $scope.hideFilter = true; }
            getLogEntries();
        });
    } else {
        var hash = $location.hash();
        if(hash) {
            hash.split('&').forEach(function(d) {
                d = d.split('=');
                if(d[0] === 'filter' && d[1]) {
                    var x = d[1].split(':');
                    $scope.linkFilter.push(new Link(x[0], Number(x[1])));
                } else if(d[0] === 'from' && d[1]) {
                    if(d[1] === 'null') {
                        _.findWhere($scope.fields, {name: 'fromDate'}).value = null;
                        _.findWhere($scope.fields, {name: 'toDate'}).value = null;
                    } else {
                        _.findWhere($scope.fields, {name: 'fromDate'}).value = Date.newFull(d[1]);
                    }
                }
            });
        }
        getLogEntries();
    }

    $scope.showFilters = function() {$scope.hideFilter = false;};
}]);

util.controller('EventLogCtrlItem', ['$rootScope', '$scope', 'log', 'Link', '$filter', function($rootScope, $scope, log, Link, $filter) {
    $scope.log = log;

    $scope.getValue = function(value) {
        if(value == null) {return;}

        if(value instanceof Date) {
            return value.dateTime();
        }

        if(value instanceof Link) {
            return $scope.getNameByLink(value);
        }

        if(Array.isArray(value)) {
            value = value.map(function(item) {
                return '' + $scope.getValue(item);
            }).join(', ');
        } else if(typeof value === 'object') {
            value = JSON.stringify(value);
        } else {
            value = '' + value;
        }

        if(value.length > 103) {
            value = value.substring(0, 100) + '...';
        }

        return value;
    };

    $scope.getPerformer = function(link, performer_name) {
        if(!link) {return '';}
        if(link.type === 'user' && link.id === $rootScope.superUserId) {
            return $filter('translate')('Zoezi support') + (performer_name ? ' (' + performer_name + ')' : '');
        }
        var obj = link.getObjectSync();
        if(!obj) {return '';}
        var prefix = $filter('translate')({staff: 'Staff', member: 'Customer', user: 'Person'}[link.type]);
        return prefix + ' ' + obj.name;
    };

    $scope.getNameByLink = function(link) {
        if(!link) {return '';}
        if(link.type === 'user' && link.id === 1) {
            return $filter('translate')('Zoezi support');
        }
        var obj = link.getObjectSync();
        if(obj) {
            return obj.name;
        }
        return $filter('translate')(link.type) + ' ' + link.id;
    };

    $scope.trace = $scope.log.trace?.replace(/\n/g, '<br/>\n');
}]);
